import { render, staticRenderFns } from "./AreaSelect.vue?vue&type=template&id=558666c8"
import script from "./AreaSelect.js?vue&type=script&lang=js&external"
export * from "./AreaSelect.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports